module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_02-e1989f1c480f65bfc4de40a717a21206.png";